import {
    EXPERTS_DELETE_ITEMS,

    EXPERTS_DELETE_ITEMS_ERROR, EXPERTS_DELETE_ITEMS_SUCCESS, EXPERTS_GET_LIST,

    EXPERTS_GET_LIST_ERROR,


    EXPERTS_GET_LIST_SEARCH, EXPERTS_GET_LIST_SUCCESS,

    EXPERTS_GET_LIST_WITH_FILTER,
    EXPERTS_GET_LIST_WITH_ORDER,

    EXPERTS_SELECTED_ITEMS_CHANGE
} from './actions_def';

const INIT_STATE = {
    allExpertsItems: [],
    experts: [],
    errors: [],
    filter: null,
    searchKeyword: '',
    orderColumn: null,
    isLoading: false,
    isLoaded: false,
    saving: false,
    labels: [
        { label: 'EDUCATION', color: 'secondary' },
        { label: 'NEW FRAMEWORK', color: 'primary' },
        { label: 'PERSONAL', color: 'info' },
    ],
    orderColumns: [
        { column: 'title', label: 'Title' },
        { column: 'category', label: 'Category' },
        { column: 'status', label: 'Status' },
        { column: 'label', label: 'Label' },
    ],
    categories: ['Flexbox', 'Sass', 'React'],
    selectedItems: [],
};

export default (state = INIT_STATE, action) => {
    switch (action.type) {
        case EXPERTS_GET_LIST:
            console.log(action.payload);
            return {
                ...state,
                isLoaded: false,
                isLoading: true
            };

        case EXPERTS_GET_LIST_SUCCESS:
            console.log(action.payload)
            return {
                ...state,
                isLoaded: true,
                isLoading: false,
                allExpertsItems: action.payload,
                experts: action.payload,
            };

        case EXPERTS_GET_LIST_ERROR:
            return {
                ...state,
                isLoaded: true,
                isLoading: false,
                error: action.payload
            };

        case EXPERTS_GET_LIST_WITH_FILTER:
            if (action.payload.column === '' || action.payload.value === '') {
                return {
                    ...state,
                    isLoaded: true,
                    isLoading: false,
                    experts: state.allExpertsItems,
                    filter: null,
                };
            }
            // eslint-disable-next-line no-case-declarations
            const filteredItems = state.allExpertsItems.filter(
                (item) => item[action.payload.column] === action.payload.value
            );
            return {
                ...state,
                isLoaded: true,
                isLoading: false,
                experts: filteredItems,
                filter: {
                    column: action.payload.column,
                    value: action.payload.value,
                },
            };

        case EXPERTS_GET_LIST_WITH_ORDER:
            if (action.payload === '') {
                return {
                    ...state,
                    isLoaded: true,
                    isLoading: false,
                    experts: state.experts,
                    orderColumn: null,
                };
            }
            // eslint-disable-next-line no-case-declarations
            const sortedItems = state.experts.sort((a, b) => {
                if (a[action.payload] < b[action.payload]) return -1;
                if (a[action.payload] > b[action.payload]) return 1;
                return 0;
            });
            return {
                ...state,
                isLoaded: true,
                isLoading: false,
                experts: sortedItems,
                orderColumn: state.orderColumns.find(
                    (x) => x.column === action.payload
                ),
            };

        case EXPERTS_GET_LIST_SEARCH:
            if (action.payload === '') {
                return { ...state, experts: state.allExpertsItems };
            }
            // eslint-disable-next-line no-case-declarations
            const keyword = action.payload.toLowerCase();
            // eslint-disable-next-line no-case-declarations
            const searchItems = state.allExpertsItems.filter(
                (item) =>
                    item.title.toLowerCase().indexOf(keyword) > -1 ||
                    item.detail.toLowerCase().indexOf(keyword) > -1 ||
                    item.status.toLowerCase().indexOf(keyword) > -1 ||
                    item.category.toLowerCase().indexOf(keyword) > -1 ||
                    item.label.toLowerCase().indexOf(keyword) > -1
            );
            return {
                ...state,
                isLoaded: true,
                isLoading: false,
                experts: searchItems,
                searchKeyword: action.payload,
            };

        case EXPERTS_SELECTED_ITEMS_CHANGE:
            return { ...state, isLoaded: true, selectedItems: action.payload };

        case EXPERTS_DELETE_ITEMS:
            return {
                ...state,
                isLoading: true,
                saving: true
            };

        case EXPERTS_DELETE_ITEMS_SUCCESS:

            return {
                ...state,
                isLoaded: true,
                isLoading: false,
                saving: false,
                saved: true,
                errors: [],
                allExpertsItems: state.allExpertsItems.filter(item => item.id !== action.payload.rfc_id),
                experts: state.experts.filter(item => item.id !== action.payload.rfc_id),
            };

        case EXPERTS_DELETE_ITEMS_ERROR:
            console.log("Failed", action.payload)
            return {
                ...state,
                isLoaded: true,
                isLoading: false,
                saving: false,
                saved: true,
                errors: action.payload.errors.map(error => (
                    {
                        field: error.field,
                        error_code: error.code
                    }
                ))
            };

        default:
            return { ...state };
    }
};
